import { Env } from '@contexts/AppContext';
import { User } from '@utils/backend-api/currentUser';

export interface Event {
  additionalDayTimes?: string;
  address?: string;
  annualEventbriteUrl?: string;
  availability?: string;
  canRegisterNow: boolean;
  coHostsAndVips?: string;
  conferenceCall: boolean;
  ctaLabel?: string;
  date: string;
  description?: string;
  endTime?: string;
  eventAgenda?: string;
  eventSpeakers?: string;
  eventbriteUrl?: string;
  extraDays: number;
  furtherDetails?: string;
  highlight?: string;
  isCurrentUserAnnualSubscriber: boolean;
  isCurrentUserProSubscriber: boolean;
  isCurrentUserSubscriber: boolean;
  isCurrentUserYPSubscriber: boolean;
  id: number;
  leadEventbriteUrl?: string;
  location?: string;
  name: string;
  pictureUrl: string;
  proEventbriteUrl?: string;
  registrationHasPassed: boolean;
  slug: string;
  startDateIso: string;
  startTime?: string;
  timeZone?: string;
  userHasRsvpd: boolean;
  venue?: string;
  whoCanAttend?: string;
  ypEventbriteUrl?: string;
}

export interface EventShowPageProps {
  event: Event;
  eventOffer: string;
  upgradeOffer: string;
  env: Env;
  initialCurrentUser?: User;
  isGdprRequired?: boolean;
  isWebview: boolean;
}

export interface EventShowPageContentProps {
  currentUser?: User;
  event: Event;
  eventOffer: string;
  upgradeOffer: string;
}

export interface EventRegistrationProps {
  currentUser?: User;
  event: Event;
  eventOffer: string;
  upgradeOffer: string;
}

export const TIME_FORMAT: Intl.DateTimeFormatOptions = {
  weekday: 'long',
  month: 'long',
  day: 'numeric',
  year: 'numeric',
};
